// ---------- partager son résultat ----------
// Le levier de croissance gratuit des jeux de mots, celui de Wordle : un résultat qui se colle
// dans une conversation sans RIEN dévoiler, et donne envie de faire mieux. Une ligne de carrés,
// un par mot de la partie, dans l'ordre :
//   🟩 trouvé seul · 🟨 avec un indice · 🟦 révélé
// Ni le mot mystère, ni les réponses : celui qui reçoit peut jouer la même partie (le mot du jour
// est le même pour tous) sans qu'on la lui ait gâchée.

import type { PuzzlePayload } from '../shared/types';
import { t } from './i18n';
import { shareText } from './platform';
import { progress } from './store';
import { toast } from './ui';

/** La page publique du jeu, en dur comme dans Codigrid : le texte partagé part avec le lien qui
 *  y mène. `utm_source=partage` dit, dans les statistiques de Pages et de la Console Play, d'où
 *  vient le joueur. À corriger avec DEPLOY.md si le projet Pages change de nom. */
export const PUBLIC_URL = 'https://verbigrid.pages.dev/?utm_source=partage';

export function resultText(p: PuzzlePayload, stars: number, label: string): string {
  const st = progress(p.id);
  const squares = p.lines.map((_, i) => (st.r[i] ? '🟦' : st.h[i] ? '🟨' : '🟩')).join('');
  const starLine = '⭐'.repeat(stars) + '☆'.repeat(3 - stars);
  return `Verbigrid · ${label}\n${starLine}\n${squares}`;
}

export async function shareResult(p: PuzzlePayload, stars: number, label: string): Promise<void> {
  const res = await shareText({
    title: 'Verbigrid',
    text: resultText(p, stars, label),
    url: PUBLIC_URL,
  });
  if (res === 'copié') toast(t('share.copied'));
}
